import '../../ChoiceGroup.css';var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsxs, jsx } from "react/jsx-runtime";
import "../../Utilities.js";
import "../../Styling.js";
import { ChoiceGroup as ChoiceGroup$2 } from "@fluentui/react/lib/ChoiceGroup";
import { ReadOnlyField } from "../ReadOnly/ReadOnlyField.js";
import "../Label/index.js";
import "../Text.js";
import "../Stack.js";
import { mergeStyles } from "@fluentui/style-utilities";
import { Stack } from "../Stack/Stack.js";
import { Text } from "@fluentui/react/lib/Text";
import { getId, css } from "@fluentui/utilities";
import { Label } from "../Label/Label.js";
const ChoiceGroup$1 = "";
const defaultClassName = "ane-ChoiceGroup";
const _onRenderLabel = (props) => {
  const { text, description, className, labelId } = props || {};
  return /* @__PURE__ */ jsxs("span", { id: labelId, className: mergeStyles(className, "ms-ChoiceFieldLabel", { fontWeight: "600" }), children: [
    text,
    description && /* @__PURE__ */ jsx(Stack, { children: /* @__PURE__ */ jsx(Text, { styles: { root: { marginTop: "10px" } }, children: description }) })
  ] });
};
const ChoiceGroup = (props) => {
  var _b;
  const _a = props, {
    className,
    id = getId("ChoiceGroup"),
    required = false,
    disabled = false,
    label,
    labelProps,
    isReadOnly,
    selectedKey,
    options
  } = _a, rest = __objRest(_a, [
    "className",
    "id",
    "required",
    "disabled",
    "label",
    "labelProps",
    "isReadOnly",
    "selectedKey",
    "options"
  ]);
  const labelId = `${id}-label`;
  const value = (_b = options == null ? void 0 : options.find((option) => option.key === selectedKey)) == null ? void 0 : _b.text;
  const ariaLabelledBy = !!label ? labelId : "";
  const defaultOptions = !!options ? options == null ? void 0 : options.map((option) => {
    const _a2 = option, { onRenderLabel = _onRenderLabel } = _a2, rest2 = __objRest(_a2, ["onRenderLabel"]);
    return __spreadProps(__spreadValues({}, rest2), { onRenderLabel });
  }) : void 0;
  return !!isReadOnly ? /* @__PURE__ */ jsx(ReadOnlyField, { id, label, value }) : /* @__PURE__ */ jsxs("div", { id, children: [
    !!label && /* @__PURE__ */ jsx(Label, __spreadProps(__spreadValues({}, labelProps), { htmlFor: `${id}-component`, id: labelId, required, disabled, children: label })),
    /* @__PURE__ */ jsx(
      ChoiceGroup$2,
      __spreadProps(__spreadValues({}, rest), {
        ariaLabelledBy,
        className: css(defaultClassName, className),
        disabled,
        selectedKey,
        id: `${id}-component`,
        options: defaultOptions
      })
    )
  ] });
};
export {
  ChoiceGroup,
  ChoiceGroup as default
};
//# sourceMappingURL=ChoiceGroup.js.map
